import { addHeaderInterceptor as r } from "./add-header-interceptor-factory.js";
import { env as t } from "../../envManager.js";
const n = (e) => e.interceptors.request.use(
  r("x-origin", t.generateGetter("xOriginHeaderValue"))
);
export {
  n as default
};
//# sourceMappingURL=origin-interceptor.js.map
